<div class="auth-flow-logo-container" *ngIf="isMember$ | async">
  <img src="assets/logo/dark/css-logo.svg" alt="CSS Logo" i18n-alt />
</div>

<div class="d-flex flex-column" [style.gap.rem]="2">
  <div class="d-flex flex-column gap-1">
    <div class="header" i18n>Reset Password</div>
    <div class="subtext" i18n>Enter your email and we'll send you a link to reset your password.</div>
  </div>

  <div class="d-flex flex-column w-100 gap-4" [formGroup]="formGroup">
    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'email'" i18n>Email</label>
      <app-email-input
        #emailInput
        formControlName="email"
        controlId="email"
        [error]="(formSubmitted && formGroup.controls.email.invalid) || ((requestFailed$ | async) ?? false)" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.email.invalid"
        [errors]="formGroup.controls.email.errors"
        [customErrorMessages]="customErrorMessages.email" />
    </div>
  </div>

  <app-button
    class="w-100"
    [type]="ButtonTypeEnum.primary"
    [disabled]="(emailSent$ | async) ?? false"
    (buttonClick)="resetPassword()">
    {{ (emailSent$ | async) ? emailSentText : resetPasswordText }}
  </app-button>

  <div class="subtext" *ngIf="emailSent$ | async" i18n>
    The email has been sent to the address above with a link to set a new password.
  </div>
</div>
